module.exports = __webpack_public_path__ + "img/change_2.c0d5f4f7.png";